import React from "react";
import { RefreshCw, WifiOff } from "lucide-react";

export function PageLoading({ rows = 6, label = "Cargando música…", testid = "page-loading" }) {
  return (
    <div data-testid={testid} className="space-y-3" aria-busy="true">
      <div className="flex items-center gap-3 text-white/50 text-sm mb-4">
        <span className="relative flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-600" /></span>
        {label}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-xl bg-white/[0.03] border border-white/5 px-3 py-2.5 animate-pulse" style={{ animationDelay: `${i * 80}ms` }}>
          <div className="w-11 h-11 rounded-lg bg-white/10 shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-3 rounded bg-white/10" style={{ width: `${55 - (i % 3) * 10}%` }} />
            <div className="h-2.5 rounded bg-white/5" style={{ width: `${35 - (i % 2) * 8}%` }} />
          </div>
          <div className="w-16 h-7 rounded-full bg-white/5" />
        </div>
      ))}
    </div>
  );
}

export function LoadError({ onRetry, message = "No se pudo cargar el contenido.", testid = "load-error" }) {
  return (
    <div data-testid={testid} className="border border-dashed border-red-900/50 bg-red-950/10 rounded-2xl py-16 px-6 text-center">
      <WifiOff className="w-8 h-8 text-red-500 mx-auto mb-3" />
      <p className="text-white/80 font-semibold mb-1">{message}</p>
      <p className="text-white/40 text-sm mb-6">El servidor está tardando en responder. Inténtalo de nuevo.</p>
      <button type="button" onClick={onRetry} data-testid={`${testid}-retry`}
        className="btn-red text-white px-6 py-2.5 rounded-full font-semibold inline-flex items-center gap-2">
        <RefreshCw className="w-4 h-4" /> Reintentar
      </button>
    </div>
  );
}
